import "core-js/modules/es.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { validationMixin } from "vuelidate";

var _require = require("vuelidate/lib/validators"),
    required = _require.required,
    maxLength = _require.maxLength,
    minLength = _require.minLength,
    alpha = _require.alpha,
    email = _require.email,
    sameAs = _require.sameAs,
    numeric = _require.numeric,
    maxValue = _require.maxValue,
    minValue = _require.minValue,
    helpers = _require.helpers;

var upperCase = helpers.regex("upperCase", /^[A-Z]*$/);
export default {
  data: function data() {
    return {
      stateOptions: ["", "Something", "Something else", "Florida"],
      locationType: "work",
      locationQualities: ["beautiful", "awesome", "wonderful"],
      firstname: "Sarah",
      lastname: "Kortney",
      location: {
        street: "10752 Deerwood Park Blvd",
        suite: "110",
        city: "Jacksonville",
        state: "Florida",
        zip: "32256"
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    locationType: {
      required: required
    },
    locationQualities: {
      required: required
    },
    firstname: {
      required: required
    },
    lastname: {
      required: required
    },
    location: {
      street: {
        required: required
      },
      suite: {
        required: required
      },
      city: {
        required: required
      },
      state: {
        required: required
      },
      zip: {
        required: required
      }
    }
  },
  methods: {
    onValitadeFormSubmit: function onValitadeFormSubmit() {
      this.$v.$touch();
      console.log(JSON.stringify({
        name: this.name,
        email: this.email,
        emailAgain: this.emailAgain,
        max: this.max,
        min: this.min,
        withRegex: this.withRegex
      }));
    }
  }
};